export function initTabSlide() {
    const tabsContainer = document.querySelector<HTMLDivElement>(".production-tabs");

    if (!tabsContainer) return;

    const tabArrowContainer = document.querySelector<HTMLDivElement>(".swiper-navigation-tab")
    const prevArrow  = tabArrowContainer.querySelector<HTMLButtonElement>(".swiper-arrow-prev");
    const nextArrow  = tabArrowContainer.querySelector<HTMLButtonElement>(".swiper-arrow-next");

    if (!tabsContainer || !prevArrow || !nextArrow) return;

    const getTabButtons = () =>
        Array.from(tabsContainer.querySelectorAll<HTMLButtonElement>(".tab-btn-production"));

    const getPaddingLeft = () => {
        const s = getComputedStyle(tabsContainer).paddingLeft;
        return parseFloat(s || "0") || 0;
    };

    const updateArrows = () => {
        // Только < 991px
        if (window.innerWidth >= 991) {
            prevArrow.style.display = "none";
            nextArrow.style.display = "none";
            return;
        }

        const scrollWidth = tabsContainer.scrollWidth;
        const clientWidth = tabsContainer.clientWidth;

        // Если контент помещается — скрываем стрелки
        if (scrollWidth <= clientWidth + 1) {
            prevArrow.style.display = "none";
            nextArrow.style.display = "none";
            return;
        }

        prevArrow.style.display = "flex";
        nextArrow.style.display = "flex";

        const maxScroll = scrollWidth - clientWidth;
        // небольшая погрешность учтена
        prevArrow.disabled = tabsContainer.scrollLeft <= 1;
        nextArrow.disabled = tabsContainer.scrollLeft >= maxScroll - 1;
    };

    // вычисляем целевой scrollLeft, чтобы btn оказался ровно у внутреннего левого края (учитываем padding-left)
    const getTargetScrollLeft = (btn: HTMLElement): number => {
        const containerRect = tabsContainer.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        const paddingLeft = getPaddingLeft();

        // delta: на сколько кнопка смещена от внутреннего левого края контейнера (в px, относительно viewport)
        const delta = btnRect.left - (containerRect.left + paddingLeft);

        // целевой scrollLeft = текущий + delta
        const raw = Math.round(tabsContainer.scrollLeft + delta);

        const maxScroll = Math.max(0, tabsContainer.scrollWidth - tabsContainer.clientWidth);
        const target = Math.min(Math.max(0, raw), maxScroll);
        return target;
    };

    // небольшая утилита throttle для обработчика scroll
    const throttle = <F extends (...args: any[]) => void>(fn: F, wait = 80) => {
        let last = 0;
        return (...args: Parameters<F>) => {
            const now = Date.now();
            if (now - last >= wait) {
                last = now;
                fn(...args);
            }
        };
    };

    const scrollToTab = (direction: "next" | "prev") => {
        const buttons = getTabButtons();
        if (buttons.length === 0) return;

        const currentScroll = Math.round(tabsContainer.scrollLeft);

        if (direction === "next") {
            // находим первый таб, у которого целевой scrollLeft > текущего (с небольшим допуском)
            const nextBtn = buttons.find((btn) => getTargetScrollLeft(btn) > currentScroll + 4);
            if (nextBtn) {
                tabsContainer.scrollTo({ left: getTargetScrollLeft(nextBtn), behavior: "smooth" });
            } else {
                // если не найден (мы почти в конце) — долистываем в самый конец
                tabsContainer.scrollTo({ left: tabsContainer.scrollWidth - tabsContainer.clientWidth, behavior: "smooth" });
            }
        } else {
            // prev: последний таб, у которого целевой < current - допуск
            const reversed = buttons.slice().reverse();
            const prevBtnFound = reversed.find((btn) => getTargetScrollLeft(btn) < currentScroll - 4);
            if (prevBtnFound) {
                tabsContainer.scrollTo({ left: getTargetScrollLeft(prevBtnFound), behavior: "smooth" });
            } else {
                // если не найден — в начало
                tabsContainer.scrollTo({ left: 0, behavior: "smooth" });
            }
        }
    };

    // обработчики
    prevArrow.addEventListener("click", () => scrollToTab("prev"));
    nextArrow.addEventListener("click", () => scrollToTab("next"));

    tabsContainer.addEventListener("scroll", throttle(updateArrows, 60));
    window.addEventListener("resize", () => {
        // при ресайзе пересчитываем отображение стрелок
        updateArrows();
    });

    // инициализация
    updateArrows();
}